import {
  BaseSentPostAction,
  SentPostAction,
  ValidSentPostAction,
} from './types';

export type useSentPostActionsResponse = {
  stackedActions: SentPostAction[];
};

export const isValidSentPostAction = (
  action: BaseSentPostAction
): action is ValidSentPostAction => {
  return action.condition && !!action.callback;
};

// Reduce post actions and remove condition property as
// all false conditions will have been filtered out
export const reduceSentPostActions = (
  result: useSentPostActionsResponse,
  action: ValidSentPostAction
): useSentPostActionsResponse => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { condition, ...newAction } = action;
  return {
    ...result,
    stackedActions: [...result.stackedActions, newAction],
  };
};
